<template>
  <section class="partner">
    <!--    <div class="blex-top w-full pt-40 lg:pt-0 bg-black h-screen">-->
    <div class="blex w-full pt-40 lg:pt-0 bg-black  pb-0 lg:pb-190">

      <div class="blex bg-black w-full mb-40 lg:mb-60">
        <div class="text-white font-bold text-2xl lg:text-6xl blex pt-0 lg:pt-210 bottom-gradient pb-12">
          PARTNERS
        </div>
      </div>

      <div class="blex w-full lg:w-7/10">
        <div class="logo">
          <img src="@/assets/images/pages/main/partners/grouptk.png" alt="" class="w-full">
        </div>
        <div class="logo">
          <img src="@/assets/images/pages/main/partners/coinness.png" alt="" class="w-full">
        </div>
        <div class="logo">
          <img src="@/assets/images/pages/main/partners/satoshiclub.png" alt="" class="w-full">
        </div>
        <div class="logo">
          <img src="@/assets/images/pages/main/partners/blockpatch.png" alt="" class="w-full">
        </div>
        <div class="logo">
          <img src="@/assets/images/pages/main/partners/ivymarket.png" alt="" class="w-full">
        </div>
        <div class="logo">
          <img src="@/assets/images/pages/main/partners/launchpadia2.png" alt="" class="w-full">
        </div>
        <div class="logo">
          <img src="@/assets/images/pages/main/partners/rocknblock.png" alt="" class="w-full">
        </div>
        <div class="logo">
          <img src="@/assets/images/pages/main/partners/dreamIdeaSoft.png" alt="" class="w-full">
        </div>
        <div class="logo">
          <img src="@/assets/images/pages/main/partners/tofunft.png" alt="" class="w-full">
        </div>
        <div class="logo">
          <img src="@/assets/images/pages/main/partners/wonderking.png" alt="" class="w-full">
        </div>
        <div class="logo">
          <img src="@/assets/images/pages/main/partners/elseLogo.png" alt="" class="w-full">
        </div>
      </div>

      <!-- partners images     -->
      <!--      <div class="blex flex-no-wrap scroll-bar-hidden image-container">-->
      <!--        <div class="flex-no-wrap blex-left bg-white py-20 lg:py-40">-->
      <!--          <img src="@/assets/images/pages/main/partners/certik.png" alt="" class="ml-110">-->
      <!--          <img src="@/assets/images/pages/main/partners/blockpatch.png" alt="" class="ml-110">-->
      <!--          <img src="@/assets/images/pages/main/partners/coinness.png" alt="" class="ml-110">-->
      <!--          <img src="@/assets/images/pages/main/partners/dreamIdeaSoft.png" alt="" class="ml-110">-->
      <!--          <img src="@/assets/images/pages/main/partners/gopax.png" alt="" class="ml-110">-->
      <!--          <img src="@/assets/images/pages/main/partners/mexc.png" alt="" class="ml-110">-->
      <!--          <img src="@/assets/images/pages/main/partners/pancakeswap.png" alt="" class="ml-110">-->
      <!--          <img src="@/assets/images/pages/main/partners/xangle.png" alt="" class="ml-110">-->
      <!--        </div>-->
      <!--        <div class="flex-no-wrap blex-left bg-white py-20 lg:py-40">-->
      <!--          <img src="@/assets/images/pages/main/partners/certik.png" alt="" class="ml-110">-->
      <!--          <img src="@/assets/images/pages/main/partners/blockpatch.png" alt="" class="ml-110">-->
      <!--          <img src="@/assets/images/pages/main/partners/coinness.png" alt="" class="ml-110">-->
      <!--          <img src="@/assets/images/pages/main/partners/dreamIdeaSoft.png" alt="" class="ml-110">-->
      <!--          <img src="@/assets/images/pages/main/partners/gopax.png" alt="" class="ml-110">-->
      <!--          <img src="@/assets/images/pages/main/partners/mexc.png" alt="" class="ml-110">-->
      <!--          <img src="@/assets/images/pages/main/partners/pancakeswap.png" alt="" class="ml-110">-->
      <!--          <img src="@/assets/images/pages/main/partners/xangle.png" alt="" class="ml-110">-->
      <!--        </div>-->
      <!--        <div class="flex-no-wrap blex-left bg-white py-20 lg:py-40">-->
      <!--          <img src="@/assets/images/pages/main/partners/certik.png" alt="" class="ml-110">-->
      <!--          <img src="@/assets/images/pages/main/partners/blockpatch.png" alt="" class="ml-110">-->
      <!--          <img src="@/assets/images/pages/main/partners/coinness.png" alt="" class="ml-110">-->
      <!--          <img src="@/assets/images/pages/main/partners/dreamIdeaSoft.png" alt="" class="ml-110">-->
      <!--          <img src="@/assets/images/pages/main/partners/gopax.png" alt="" class="ml-110">-->
      <!--          <img src="@/assets/images/pages/main/partners/mexc.png" alt="" class="ml-110">-->
      <!--          <img src="@/assets/images/pages/main/partners/pancakeswap.png" alt="" class="ml-110">-->
      <!--          <img src="@/assets/images/pages/main/partners/xangle.png" alt="" class="ml-110">-->
      <!--        </div>-->
      <!--        <div class="flex-no-wrap blex-left bg-white py-20 lg:py-40">-->
      <!--          <img src="@/assets/images/pages/main/partners/certik.png" alt="" class="ml-110">-->
      <!--          <img src="@/assets/images/pages/main/partners/blockpatch.png" alt="" class="ml-110">-->
      <!--          <img src="@/assets/images/pages/main/partners/coinness.png" alt="" class="ml-110">-->
      <!--          <img src="@/assets/images/pages/main/partners/dreamIdeaSoft.png" alt="" class="ml-110">-->
      <!--          <img src="@/assets/images/pages/main/partners/gopax.png" alt="" class="ml-110">-->
      <!--          <img src="@/assets/images/pages/main/partners/mexc.png" alt="" class="ml-110">-->
      <!--          <img src="@/assets/images/pages/main/partners/pancakeswap.png" alt="" class="ml-110">-->
      <!--          <img src="@/assets/images/pages/main/partners/xangle.png" alt="" class="ml-110">-->
      <!--        </div>-->
      <!--      </div>-->

    </div>

  </section>

</template>

<script>
export default {
  name: 'Partner'
}
</script>

<style scoped lang="scss">
section::v-deep {
  .logo {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
    margin: 10px;
    width: 150px;
    height: 150px;
    background: #fff;
    transition: all .2s;
    border: 2px solid rgba(0, 0, 0, .4);

    &:hover {
      transform: scale(1.2);
      transition: all .2s;
    }

    @media screen and (max-width: 1024px) {
      width: 100px;
      height: 100px;
      padding: 12px;


    }

  }

  //.image-container {
  //  animation: slide 10s linear infinite;
  //  transform: translate3d(0, 0, 0);
  //}

  //@keyframes slide {
  //
  //  0% {
  //    transform: translate3d(0vw, 0, 0);
  //  }
  //  100% {
  //    transform: translate3d(-99vw, 0, 0);
  //  }
  //}

}

</style>
